import React, {MouseEvent, useCallback} from 'react';
import {ButtonNew} from 'components/ButtonNew';
import {IProductSnippet} from 'shared/types/productSnippet.types';

type TReserveButtonProps = Pick<IProductSnippet['cart'], 'onReserve'> & Pick<IProductSnippet, 'url'> & {text?: string};

export const ReserveButton = (props: TReserveButtonProps) => {
    const {onReserve, url, text = 'Забронировать'} = props;

    // href нужен только как семантическая ссылка на товар (SEO/фолбэк) — клик открывает
    // флоу бронирования, а не переходит на PDP
    const handleClick = useCallback(
        (e: MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
            e.preventDefault();
            onReserve?.();
        },
        [onReserve],
    );

    return (
        <ButtonNew
            href={url}
            isStretched={true}
            variants={{DT: 'medium', TB: 'small', MB: 'small'}}
            theme={'black'}
            onClick={handleClick}
        >
            {text}
        </ButtonNew>
    );
};
